import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import FooterDocument from 'utils/__enums/Footer/FooterDocument'
import logo from 'assets/logo_footer.png'
import ROUTES from 'utils/ROUTES'

const Footer: React.FC = () => {
  const { t } = useTranslation()

  const url = `${process.env.REACT_APP_FOOTER_URL_PDF}resources/`

  return (
    <footer className="footer">
      <div className="footer__container container">
        <div className="footer__links row">
          <div className="col-sm-6 mw-100 d-lg-flex justify-content-between">
            <div>
              <div className="my-2">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`${url}${FooterDocument.CGU}`}
                >
                  {t('footer.links.cgu')}
                </a>
              </div>
              <div className="my-2">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`${url}${FooterDocument.CGV}`}
                >
                  {t('footer.links.cgv')}
                </a>
              </div>
              <div className="my-2">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`${url}${FooterDocument.COOKIES_CHARTE}`}
                >
                  {t('footer.links.cookies')}
                </a>
              </div>
              <div className="my-2">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`${url}${FooterDocument.LEGAL_NOTICES}`}
                >
                  {t('footer.links.legal')}
                </a>
              </div>
              <div className="my-2">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={ROUTES.PrivatePolicy}
                >
                  {t('footer.links.confidentiality')}
                </a>
              </div>
            </div>
            <div className="my-2">
              <Link to={ROUTES.MobileAppDownload}>
                {t('footer.links.mobileApp')}
              </Link>
            </div>
          </div>
          <div className="col-sm-6 mw-100 d-flex justify-content-center align-items-center">
            <div className="footer__left mt-4 w-100 text-center">
              <img src={logo} alt="suez logo" className="logo mw-100 ml-0" />
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
